module.exports = __webpack_public_path__ + "img/sv.6b4802fb.svg";